import { useEffect } from 'react';
import { navigate } from 'gatsby';
import { useQueryClient } from 'react-query';
import { useMeQuery } from 'lib/home/generated/queries';
import { RegistrationRouteMap, useAuthStore, useRegistrationStore } from '../../store';
import { Loading } from '../../components';

const GettingStartedRedirectPage = () => {
  const queryClient = useQueryClient();
  const { token } = useAuthStore();
  const { selectedPlan, preferences, checkoutInfo } = useRegistrationStore();
  const { data: { me } = {}, refetch: refetchMeData } = useMeQuery();

  useEffect(() => {
    if (!me) return;
    if (!checkoutInfo?.postal_code || !me?.postal_code) {
      navigate('/getting-started');
      return;
    }
    if (!selectedPlan && !me?.subscription) {
      navigate(RegistrationRouteMap.selectPlan);
      return;
    }
    if (!preferences?.diets && !me?.meal_preferences) {
      navigate(RegistrationRouteMap.preferences);
      return;
    }

    navigate(RegistrationRouteMap.orderSummary);
  }, [me, preferences, queryClient, selectedPlan, token, refetchMeData, checkoutInfo]);

  return <Loading />;
};

export default GettingStartedRedirectPage;
